import { useQuery } from '@tanstack/react-query'
import { EngagementInsightsMockData } from 'src/pages/ContentAnalysisDetail/mockData/engagementInsightsMockData'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'

interface EngagementInsightsResponse {
  data: EngagementInsightsMockData
}

interface UseGetContentAnalysisEngagementInsightsQueryParams {
  fromDate?: string
  id: string
  toDate?: string
}

export const useGetContentAnalysisEngagementInsightsQuery = ({
  fromDate,
  id,
  toDate,
}: UseGetContentAnalysisEngagementInsightsQueryParams) => {
  return useQuery({
    enabled: !!id,
    queryFn: () =>
      ContentAnalysisApiService.getEngagementInsights<EngagementInsightsResponse>(
        id,
        { fromDate, toDate }
      ),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_ENGAGEMENT_INSIGHTS,
      id,
      fromDate,
      toDate,
    ],
  })
}
